<template>
  <span
    class="timer"
    v-if="showTimer"
    role="timer"
    aria-label="Zeit für die der Termin reserviert ist"
  >
    <span class="h4">• </span>
    <span class="h4" :class="showText && 'timer--red'">{{ minutes + ':' + seconds }}</span>
    <span class="h4" v-show="showText"> Reservierung läuft ab</span>
    <button
      class="timer__extend-button link"
      v-if="extensionPossible && showExtendButton"
      @click="extendReservation"
    >
      Reservierung verlängern
    </button>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  totalTime: 10 * 60, // in seconds
  data() {
    return {
      timeLeft: null,
      timerInterval: null,
      showTimer: false,
      showText: false,
      showExtendButton: false,
      extensionCount: 0,
    }
  },
  activated() {
    this.showTimer = false
    this.showText = false

    if (!this.timerStartTime) this.$store.commit('setTimerStartTime', new Date().getTime())
    this.updateTimePassed()
  },
  deactivated() {
    this.extensionCount = 0
    this.showExtendButton = false
  },
  computed: {
    ...mapGetters(['activeStep', 'timerStartTime']),
    minutes() {
      let minutes = Math.floor(this.timeLeft / 60)
      if (minutes < 10) {
        minutes = `0${minutes}`
      }
      return minutes
    },
    seconds() {
      let seconds = this.timeLeft % 60
      if (seconds < 10) {
        seconds = `0${seconds}`
      }
      return seconds
    },
    extensionPossible() {
      return this.extensionCount < 1
    },
  },
  watch: {
    timeLeft() {
      if (this.timeLeft <= 5 * 60 && !this.showTimer) this.showTimer = true
      if (this.timeLeft <= 1.5 * 60 && !this.showText) this.showText = true
      if (this.timeLeft <= 0.33 * 60 && this.extensionPossible) this.showExtendButton = true
      if (this.timeLeft <= 0) {
        this.$store.commit('setActiveStep', 4)
        // reservation is automatically cancelled by backend after 10 minutes
        this.$store.commit('setTimerStartTime', null)
        clearInterval(this.timerInterval)
      }
    },
    activeStep() {
      if (this.activeStep !== 5) {
        this.$store.commit('setTimerStartTime', null)
        clearInterval(this.timerInterval)
      }
    },
  },
  methods: {
    updateTimePassed() {
      this.timerInterval = setInterval(() => {
        this.timeLeft =
          this.$options.totalTime - Math.ceil((new Date().getTime() - this.timerStartTime) / 1000)
      }, 1000)
    },
    async extendReservation() {
      try {
        await this.$store.dispatch('extendAppointmentLock')
        this.$store.commit('setTimerStartTime', new Date().getTime())
        this.updateTimePassed()
        this.extensionCount++
      } catch (error) {
        console.error('Error extending reservation:', error)
      }
    },
  },
}
</script>

<style lang="scss">
.timer {
  &--red {
    color: $color-danger-primary;
  }

  span:last-of-type {
    color: $color-danger-primary;
    font-size: 12px;
    margin-left: 4px;
  }

  &__extend-button {
    margin-left: 8px;
  }
}
</style>
